export default "__VITE_ASSET__BRmoturA__"